import { get } from "./api";

export const getConnectionStrength = async (itemId: string): Promise<any> => {
  const response = await get({ path: `/items/${itemId}/connection-strength` });
  return response.data;
};

export const getEstimatedProbability = async (itemId: string): Promise<any> => {
  const response = await get({
    path: `/items/${itemId}/estimated-probability`,
  });
  return response.data;
};
